import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@digital-services/ui";

import { useDrawerWithConfirm } from "@hooks/useDrawerWithConfirm";
import PlusIcon from "@icons/plus_16.svg?react";

import { CreateOrganizationForm } from "./CreateOrganizationForm";
import { OrganizationCreatedMessage } from "./OrganizationCreatedMessage";

export const CreateOrganizationButton: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "organization" });

  const { showDrawer, hideDrawer } = useDrawerWithConfirm();

  const createOrganization = () => {
    showDrawer({
      title: t("create.title"),
      children: (
        <CreateOrganizationForm onCancel={() => hideDrawer()} onSave={onSave} />
      )
    });
  };

  const onSave = (organizationId: string) => {
    hideDrawer();
    showDrawer({
      title: t("create.title"),
      children: (
        <OrganizationCreatedMessage
          organizationId={organizationId}
          onClose={() => hideDrawer()}
        />
      )
    });
  };

  return (
    <Button
      icon={<PlusIcon />}
      data-testid="create-organization-button"
      variant="primary"
      onClick={createOrganization}
    >
      {t("create.label")}
    </Button>
  );
};
